"use client";

import { useEffect } from "react";
import Link from "next/link";

import { Button } from "@/components/ui/button";
import { PageCenter } from "@/components/ui/page-center";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error("[GlobalError]", error);
  }, [error]);

  return (
    <PageCenter asChild>
      <main className="flex flex-col items-center gap-6 py-8">
        <div className="flex flex-col items-center gap-1 text-center">
          <h1 className="h4 text-text-grayscale-caption">
            Something went wrong
          </h1>
          <p className="body1 text-text-grayscale-body">
            An unexpected error occurred. Please try again.
          </p>
          {error.digest && (
            <p className="mt-2 font-mono text-xs text-text-grayscale-body/60">
              Digest: {error.digest}
            </p>
          )}
        </div>
        <div className="flex gap-3">
          <Button
            onClick={reset}
            className="rounded-lg bg-[#476BE1] hover:bg-[#476BE1]/90"
          >
            Try Again
          </Button>
          <Button
            asChild
            variant="outline"
            className="rounded-lg"
          >
            <Link href="/">Take Me Home</Link>
          </Button>
        </div>
      </main>
    </PageCenter>
  );
}
